import React, { Fragment, useState, useEffect, useCallback } from "react";

import ImageGallery from 'react-image-gallery';



import { db } from '../firebase'


const Galeria = () => {

    const [photosUrl, setPhotosUrl] = useState([]);

    const getPhotos = async () => {
        await db.collection('works').onSnapshot((querysnapshot) => {
            const docs = []
            querysnapshot.forEach(doc => {

                docs.push(doc.data().url)
               
            })

            setPhotosUrl(
                    docs.map(url=>({
                        original: `${url}`,
                        thumbnail: `${url}`
                    }))
            )

           
        })

       

       
    }


    

    useEffect(() => {
        getPhotos()
       
       
    }, [])

    const images = [
        {
            original: 'https://picsum.photos/id/1018/1000/600/',
            thumbnail: 'https://picsum.photos/id/1018/250/150/',
        },
        {
            original: 'https://picsum.photos/id/1015/1000/600/',
            thumbnail: 'https://picsum.photos/id/1015/250/150/',
        },
        {
            original: 'https://picsum.photos/id/1019/1000/600/',
            thumbnail: 'https://picsum.photos/id/1019/250/150/',
        },
    ];


   



    return (
        <div className='gallery'>
            <div style={{ height: '30px' }}></div>
            <ImageGallery items={photosUrl} />
        </div>

    )



}


export default Galeria;